import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters";

export default {
  namespaced: true,
  state: () => ({
    trainerReviewDialog: false,
  }),
  mutations,
  actions,
  getters,
};
